module.exports = __webpack_public_path__ + "img/dinplus_enplus.05482c8.png";